import React from 'react'
import "../styles/footer.css";

export const Footer = () => {
  return (
    <footer>
        <div className="footerData">
            <h1>PRODUCT OFFERING</h1>
            <p>
                Flights, International Flights, Charter Flights, Hotels, International Hotels, Homestays and Villas, Activities, Holidays In India, 
                International Holidays, Book Hotels From UAE, myBiz for Corporate Travel, Book Online Cabs, Book Bus Tickets, Book Train Tickets, Cheap Tickets to India, 
                Book Flights From US, Book Flights From UAE, Trip Planner, Gift Cards, Trip Money, Trip Ideas, Travel Blog, PNR Status, MakeMyTrip Advertising Solutions, 
                One Way Cab
            </p>
        </div>
        <div className="footerData">
            <h1>MAKEMYTIRP</h1>
            <p>
                About Us, Investor Relations, Careers, MMT Foundation, CSR Policy, myPartner - Travel Agent Portal, Foreign Exchange, 
                List your hotel, Partners- Redbus, Partners- Goibibo, Advertise with Us
            </p>
        </div>
        <div className="footerData">
            <h1>ABOUT THE SITE</h1>
            <p>
                Customer Support, Payment Security, Privacy Policy, User Agreement, Terms of Service, More Offices, Make A Payment, Work From Home
            </p>
        </div>
        <div className="footerData">
            <h1>TOP HOTELS IN INDIA</h1>
            <p>
                Fairmont Jaipur, St Regis Goa, Six Senses Fort Barwara, W Goa, Grand Hyatt Goa, Shangri-La Bangalore, The St Regis Mumbai, Taj Rishikesh, 
                Grand Hyatt Mumbai, Le Meridien Delhi, Rambagh Palace Jaipur, Leela Palace Chennai, The Leela Palace Udaipur, Taj Lake Palace Udaipur, 
                Jw Marriott Chandigarh, Alila Diwa Goa, Le Meridien Goa, Taj Lands End Mumbai, Itc Grand Chola Chennai, Itc Maratha Mumbai, Oberoi Udaivilas, 
                Jai Mahal Palace Jaipur, Taj Mahal Tower Mumbai, Marriott Suites Pune, Park Hyatt Chennai, The Leela Palace Jaipur, Jw Marriott Mumbai Sahar, 
                Jw Marriott Mumbai Juhu, The Ritz Carlton Bengaluru, The Oberoi New Delhi, Taj Resort & Convention Centre Goa, Taj Bengal Kolkata, Taj Coromandel Chennai, 
                The Oberoi Gurgaon, The Westin Goa, Jw Marriott Hotel Pune, The Leela Palace New Delhi, Taj West End Bengaluru, The Taj Mahal Palace Mumbai
            </p>
        </div>
        <div className="footerData">
            <h1>TOP INTERNATIONAL HOTELS</h1>
            <p>
                Adaaran Club Rannalhi, Marina Bay Sands Singapore, Coco Bodu Hithi, Taj Dubai, Atlantis Hotel Dubai, Amari Phuket, Jw Marriott Dubai, Armani Hotel Dubai, 
                Grand Hyatt Dubai, Saii Lagoon Maldives, Gevora Hotel Dubai, Hyatt Regency Dubai, Pan Pacific Singapore, The Palm Dubai, Caesars Palace, Baiyoke Sky Hotel, 
                Centara Pattaya Hotel, Embudu Village, Orchard Hotel Singapore, Reethi Beach Resort, Ambassador Hotel Bangkok, Dusit Thani Pattaya, Shangri La Singapore, 
                Sunbeam Hotel Pattaya, Taj Samudra Colombo, Bangkok Palace Hotel, Hilton Pattaya, Novotel Phuket Resort, Taj Exotica Resort Maldives, Village Hotel Bugis, 
                Avani Atrium Bangkok, The Plaza New York, Village Hotel Albert Court, Amari Pattaya
            </p>
        </div>

        <div className="footerData">
            <h1>QUICK LINKS</h1>
            <p>
                Delhi Chennai Flights, Delhi Mumbai Flights, Delhi Goa Flights, Chennai Mumbai flights, Mumbai Hyderabad flights, Kolkata to Rupsi Flights, 
                Rupsi to Guwahati Flights, Pasighat to Guwahati Flights, Delhi to Khajuraho Flights, Cochin to Agatti Island Flights, Hotels in Delhi, 
                Hotels in Mumbai, Hotels In Goa, Hotels In Jaipur, Hotels In Ooty, Hotels In Udaipur, Hotels in Puri, Hotels In North Goa, Hotels In Rishikesh, 
                Honeymoon Packages, Kerala Packages, Kashmir Packages, Ladakh Packages, Goa Packages, Thailand Packages, Sri Lanka Visa, Thailand Visa, Explore Goa, 
                Explore Manali, Explore Shimla, Explore Jaipur, Explore Srinagar
            </p>
        </div> 
        <div className="footerData">
            <h1>IMPORTANT LINKS</h1>
            <p>
                Cheap Flights, Flight Status, Kumbh Mela, Domestic Airlines, International Airlines, Indigo, Spicejet, GoAir, Air Asia, Air India, 
                Indian Railways, Trip Ideas, Beaches, Honeymoon Destinations, Romantic Destinations, Popular Destinations, Resorts In Udaipur, Resorts In Munnar, 
                Villas In Lonavala, Hotels in Thailand, Villas In Goa, Domestic Flight Offers, International Flight Offers, UAE Flight Offers, USA, UAE, Saudi Arabia, 
                UK, Oman
            </p>
        </div>
        <div className="footerData">
            <h1>CORPORATE TRAVEL</h1>
            <p>
            Corporate Travel, Corporate Hotel Booking, Corporate Flight Booking, Business Travel for SME, GST Invoice for International flights, 
            Business Travel Solutions, GST Invoice for Bus, Corporate Bus booking, myBiz - Best Business Travel Platform, GST Invoice for Flights, 
            GST Invoice for Corporate Travel, GST Invoice for Hotels, myBiz for Small Business, Free cancellation on International Flights
            </p>
        </div>

        <div className="footerTerms">
            <div className="footerCard">
                <h1>Why MakeMyTrip?</h1>
                <p>
                    Established in 2000, MakeMyTrip has since positioned itself as one of the leading companies, providing great offers, competitive airfares, 
                    exclusive discounts, and a seamless online booking experience to many of its customers. The experience of booking your flight tickets, hotel stay, 
                    and holiday package through our desktop site or mobile app can be done with complete ease and no hassles at all. We also deliver amazing offers, 
                    such as Instant Discounts, Fare Calendar, MyRewardsProgram, MyWallet, and many more while updating them from time to time to better suit our customers’ 
                    evolving needs and demands.
                </p>
            </div>
            <div className="footerCard">
                <h1>Booking Flights with MakeMyTrip</h1>
                <p>
                    At MakeMyTrip, you can find the best of deals and cheap air tickets to any place you want by booking your tickets on our website or app. 
                    Being India’s leading website for hotel, flight, and holiday bookings, MakeMyTrip helps you book flight tickets that are affordable and customized 
                    to your convenience. With customer satisfaction being our ultimate goal, we also have a 24/7 dedicated helpline to cater to our customer’s 
                    queries and concerns. Serving over 5 million happy customers, we at MakeMyTrip are glad to fulfill the dreams of folks who need a quick and easy 
                    means to find air tickets. You can get a hold of the cheapest flight of your choice today while also enjoying the other available options for your 
                    travel needs with us.
                </p>
            </div>
            <div className="footerCard">
                <h1>Domestic Flights with MakeMyTrip</h1>
                <p>
                    MakeMyTrip is India's leading player for flight bookings. With the cheapest fare guarantee, experience great value at the lowest price. 
                    Instant notifications ensure current flight status, instant fare drops, amazing discounts, instant refunds and rebook options, 
                    price comparisons and many more interesting features.
                </p>
            </div>
        </div>

        <div className="footerLastBx">
            <div className="footerIcons">
                <i className="fa fa-twitter"></i>
                <i className="fa fa-facebook"></i>
            </div>
            <div className="footerCopyrightbx">
                <h1>© 2023 MAKEMYTRIP PVT. LTD.</h1>
                <h2>Country <b>India USA UAE</b></h2>
            </div>
        </div>

    </footer>
  )
}
